// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const ArrowBottom_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm19.28 14.03-6.75 6.75a.75.75 0 0 1-1.06 0l-6.75-6.75a.75.75 0 0 1 1.06-1.06l5.47 5.47V3.75a.75.75 0 0 1 1.5 0v14.69l5.47-5.47a.75.75 0 0 1 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowBottom_Stroke2_Corner0_Rounded',
})

export const ArrowBoxLeft_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 16.5h-15v-15h15ZM7.72 12.53a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72h5.69a.75.75 0 0 1 0 1.5h-5.69l1.72 1.72a.75.75 0 0 1-1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowBoxLeft_Stroke2_Corner0_Rounded',
})

export const ArrowBoxLeft_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M11.25 20.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 4.5 3h6a.75.75 0 0 1 0 1.5H5.25v15h5.25a.75.75 0 0 1 .75.75Zm10.28-8.78-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47H10.5a.75.75 0 0 0 0 1.5h8.69l-2.47 2.47a.75.75 0 0 0 1.06 1.06l3.75-3.75a.75.75 0 0 0 0-1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowBoxLeft_Stroke2_Corner2_Rounded',
})

export const ArrowBoxRight_Stroke2_Corner3_Rounded = createSinglePathSVG({
  path: 'M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 16.5h-15v-15h15ZM7.5 12a.75.75 0 0 1 .75-.75h5.69l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H8.25A.75.75 0 0 1 7.5 12Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowBoxRight_Stroke2_Corner3_Rounded',
})

export const ArrowCornerDownRight_Stroke2_Corner2_Rounded = createSinglePathSVG(
  {
    path: 'm21.53 15.53-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V6.75H3a.75.75 0 0 1 0-1.5h13.5a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 0 1 1.06 1.06Z',
    viewBox: '0 0 24 24',
    glyph: 'ArrowCornerDownRight_Stroke2_Corner2_Rounded',
  },
)

export const ArrowCornerDownRight_Stroke2_Corner3_Rounded = createSinglePathSVG(
  {
    path: 'm21.53 15.53-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V6.75H3a.75.75 0 0 1 0-1.5h13.5a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 0 1 1.06 1.06Z',
    viewBox: '0 0 24 24',
    glyph: 'ArrowCornerDownRight_Stroke2_Corner3_Rounded',
  },
)

export const ArrowLeft_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 12a.75.75 0 0 1-.75.75H5.56l5.47 5.47a.75.75 0 0 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 0 1 1.06 1.06l-5.47 5.47h14.69A.75.75 0 0 1 21 12Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowLeft_Stroke2_Corner0_Rounded',
})

export const ArrowOutOfBox_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 9.75a.75.75 0 0 1-1.5 0V5.561l-6.218 6.22a.75.75 0 0 1-1.062-1.062L18.44 4.5h-4.19a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75ZM17.25 12a.75.75 0 0 0-.75.75v6.75h-12v-12h6.75a.75.75 0 0 0 0-1.5H4.5A1.5 1.5 0 0 0 3 7.5v12A1.5 1.5 0 0 0 4.5 21h12a1.5 1.5 0 0 0 1.5-1.5v-6.75a.75.75 0 0 0-.75-.75Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowOutOfBox_Stroke2_Corner0_Rounded',
})

export const ArrowOutOfBoxModified_Stroke2_Corner2_Rounded =
  createSinglePathSVG({
    path: 'M21 9.75a.75.75 0 0 1-1.5 0V5.561l-6.218 6.22a.75.75 0 0 1-1.062-1.062L18.44 4.5h-4.19a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75ZM17.25 12a.75.75 0 0 0-.75.75v6.75h-12v-12h6.75a.75.75 0 0 0 0-1.5H4.5A1.5 1.5 0 0 0 3 7.5v12A1.5 1.5 0 0 0 4.5 21h12a1.5 1.5 0 0 0 1.5-1.5v-6.75a.75.75 0 0 0-.75-.75Z',
    viewBox: '0 0 24 24',
    glyph: 'ArrowOutOfBoxModified_Stroke2_Corner2_Rounded',
  })

export const ArrowRight_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.78 12.53-6.75 6.75a.75.75 0 0 1-1.06-1.06l5.47-5.47H3.75a.75.75 0 0 1 0-1.5h14.69l-5.47-5.47a.75.75 0 0 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowRight_Stroke2_Corner0_Rounded',
})

export const ArrowRotateClockwise_Stroke2_Corner0_Rounded = createSinglePathSVG(
  {
    path: 'M21 4.5V9a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-1.372-1.372a7.46 7.46 0 0 0-5.262-2.196h-.042a7.46 7.46 0 0 0-5.24 2.135.75.75 0 0 1-1.048-1.073 9 9 0 0 1 12.656.074L19.5 7.19V4.5a.75.75 0 0 1 1.5 0Zm-3.524 12.683a7.5 7.5 0 0 1-10.544-.061L5.56 15.75h2.69a.75.75 0 0 0 0-1.5h-4.5A.75.75 0 0 0 3 15v4.5a.75.75 0 0 0 1.5 0v-2.69l1.372 1.372a8.95 8.95 0 0 0 6.316 2.636h.05a8.94 8.94 0 0 0 6.287-2.562.75.75 0 0 0-1.048-1.073Z',
    viewBox: '0 0 24 24',
    glyph: 'ArrowRotateClockwise_Stroke2_Corner0_Rounded',
  },
)

export const ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M8.25 9.75h-4.5A.75.75 0 0 1 3 9V4.5a.75.75 0 0 1 1.5 0v2.69l1.372-1.372a8.95 8.95 0 0 1 6.316-2.636h.05a8.94 8.94 0 0 1 6.287 2.562.75.75 0 0 1-1.048 1.073 7.46 7.46 0 0 0-5.24-2.135h-.042a7.46 7.46 0 0 0-5.263 2.196L5.56 8.25h2.69a.75.75 0 0 1 0 1.5Zm12 4.5h-4.5a.75.75 0 0 0 0 1.5h2.69l-1.372 1.372a7.46 7.46 0 0 1-5.262 2.196h-.042a7.46 7.46 0 0 1-5.24-2.135.75.75 0 1 0-1.048 1.073 8.94 8.94 0 0 0 6.288 2.562h.049a8.95 8.95 0 0 0 6.314-2.636L19.5 16.81v2.69a.75.75 0 0 0 1.5 0V15a.75.75 0 0 0-.75-.75Z',
    viewBox: '0 0 24 24',
    glyph: 'ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded',
  })

export const ArrowShareRight_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'm22.28 9.97-7.5-7.5A.75.75 0 0 0 13.5 3v3.783c-2.432.208-5.118 1.399-7.327 3.273-2.661 2.257-4.318 5.166-4.665 8.19a1.125 1.125 0 0 0 1.938.899h0c1.031-1.098 4.7-4.57 10.054-4.875V18a.75.75 0 0 0 1.28.53l7.5-7.5a.75.75 0 0 0 0-1.06ZM15 16.19V13.5a.75.75 0 0 0-.75-.75c-2.632 0-5.197.687-7.62 2.044A18.4 18.4 0 0 0 3.2 17.28c.544-2.235 1.915-4.36 3.943-6.08 2.177-1.847 4.834-2.95 7.107-2.95A.75.75 0 0 0 15 7.5V4.811l5.69 5.689Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowShareRight_Stroke2_Corner2_Rounded',
})

export const ArrowTop_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.28 11.03a.75.75 0 0 1-1.06 0l-5.47-5.47v14.69a.75.75 0 0 1-1.5 0V5.56l-5.47 5.47a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 0 1 0 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowTop_Stroke2_Corner0_Rounded',
})

export const ArrowTopCircle_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25Zm3.53-9.53a.75.75 0 0 1-1.06 1.06l-1.72-1.72v5.69a.75.75 0 0 1-1.5 0v-5.69l-1.72 1.72a.75.75 0 0 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowTopCircle_Stroke2_Corner0_Rounded',
})

export const ArrowTopRight_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M18.75 6v9.75a.75.75 0 0 1-1.5 0V7.81L6.53 18.53a.75.75 0 0 1-1.06-1.06L16.19 6.75H8.25a.75.75 0 0 1 0-1.5H18a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowTopRight_Stroke2_Corner0_Rounded',
})

export const ArrowTriangleBottom_Stroke2_Corner1_Rounded = createSinglePathSVG({
  path: 'm20.03 9.53-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 15.44l6.97-6.97a.75.75 0 0 1 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ArrowTriangleBottom_Stroke2_Corner1_Rounded',
})
